import { bulletSection } from '../helper'

export default [
  {
    generate({ answers }) {
      const textPieces = []

      if (['<150', 'nao-disponivel'].includes(answers['38'])) {
        textPieces.push(
          `Eosinófilos no sangue periférico: ${answers['38'].replace('-', ' a ').replace('>=', '≥')} (células/μL)`,
        )
      }

      if (answers['35'] === 'sim') {
        textPieces.push(
          `Prick test positivo (teste cutâneo de hipersensibilidade imediata ou teste cutâneo por puntura)`,
        )
      }

      if (answers['36'] === 'sim') {
        textPieces.push(`IgE sérica específica positiva para pelo menos um aeroalérgeno`)
      }

      if (answers['37'] === '30-1500') {
        textPieces.push(`IgE total sérica com valor entre 30 a 1.500 UI/m`)
      }

      if (answers['39'] === 'sim') {
        textPieces.push(`FeNO (Fração exalada de óxido nítrico) aumentada`)
      }

      const sections = []

      if (textPieces.length) {
        sections.push(bulletSection('Aos exames laboratoriais, apresenta:', textPieces))
      }

      return sections
    },
    version: {
      /** @type {number[]} */
      include: [1],
      /** @type {number[]} */
      exclude: [],
    },
  },
  {
    generate({ answers }) {
      const textPieces = []

      if (answers['38'] >= 150) {
        textPieces.push(`Eosinófilos no sangue periférico: ${answers['38']} (células/μL)`)
      }

      if (answers['35'] === 'sim') {
        textPieces.push(
          `Prick test positivo (teste cutâneo de hipersensibilidade imediata ou teste cutâneo por puntura)`,
        )
      }

      if (answers['36'] === 'sim') {
        textPieces.push(`IgE sérica específica positiva para pelo menos um aeroalérgeno`)
      }

      if (answers['37'] === '30-1500') {
        textPieces.push(`IgE total sérica com valor entre 30 a 1.500 UI/m`)
      }

      if (answers['39'] === 'sim') {
        textPieces.push(`FeNO (Fração exalada de óxido nítrico) aumentada`)
      }

      const sections = []

      if (textPieces.length) {
        sections.push(bulletSection('Aos exames laboratoriais, apresenta:', textPieces))
      }

      return sections
    },
    version: {
      /** @type {number[]} */
      include: [],
      /** @type {number[]} */
      exclude: [1],
    },
  },
]
